<template>
  <div class="flex items-center my-3">
    <Avatar
      :src="avatarUrl"
      :size="80"
    />

    <Spinner v-if="uploading" class="mx-2" />
    <label v-else class="file-select btn btn--primary mx-2">
      <span>{{ $t('Change Photo') }}</span>
      <!-- Now, the file input that we hide. -->
      <input type="file" @change="handleFileChange" />
    </label>

    <span v-if="hasError" class="text-danger mx-2">
      Ce fichier ne semble pas être une image valide (JPG ou PNG).
    </span>
  </div>
</template>

<script>
import { post } from '@/modules/api';
import Avatar from '@/components/Avatar.vue';
import Spinner from '@/components/Spinner.vue';

export default {
  components: {
    Avatar,
    Spinner,
  },

  data: () => ({
    uploading: false,
    hasError: false,
  }),

  computed: {
    avatarUrl() {
      return this.$store.state.user.avatarUrl;
    },
  },

  methods: {
    handleFileChange(e) {
      const formData = new FormData();
      formData.append('avatar', e.target.files[0]);

      this.uploading = true;
      post('/upload', formData)
        .then(user => {
          this.uploading = false;
          this.hasError = false;
          this.$store.dispatch('EDIT_USER', user);
        })
        .catch(() => {
          this.uploading = false;
          this.hasError = true;
        });
    },
  },
};
</script>

<style scoped>
.file-select {
  position: relative;
}

.file-select > input[type='file'] {
  position: absolute;
  opacity: 0;
}
</style>
